import { DocumentType } from '@superbet-group/web.lib.config';

import User from '@core/models/user/User';
import { ValidationErrorTranslationKey } from '@superbet-group/web.types';

type Field<ValueType = string> = {
    value: ValueType;
    validate?: Array<(value?: ValueType) => boolean | ValidationErrorTranslationKey>;
};

type SwitchField<ValueType = string> = {
    value: ValueType;
    options: {
        first: {
            label: string;
            value: ValueType;
        };
        second: {
            label: string;
            value: ValueType;
        };
    };
};

export const PhotoDeliveryMethods = {
    Capture: 'Capture',
    Upload: 'Upload',
} as const;
export type PhotoDeliveryMethods = typeof PhotoDeliveryMethods[keyof typeof PhotoDeliveryMethods];

export const verifyIdentityExpIds = {
    Old: 'old',
    New: 'new',
} as const;
export type verifyIdentityExpIds = typeof verifyIdentityExpIds[keyof typeof verifyIdentityExpIds];

export const verifyIdentityEntrypoints = {
    Notification: 'notification',
    NotificationCompleteRegistration: 'notificationCompleteRegistration',
    Deposit: 'deposit',
    Withdrawal: 'withdrawal',
    Upload: 'upload',
} as const;
export type verifyIdentityEntrypoints = typeof verifyIdentityEntrypoints[keyof typeof verifyIdentityEntrypoints];

export interface EventDto {
    darklyExpId: verifyIdentityExpIds;
    kycStatus: string;
    completedRegistration: boolean;
    source: verifyIdentityEntrypoints;
    type: DocumentType;
    method: PhotoDeliveryMethods;
}

export interface EventParamsDto {
    user: User;
    kycVersion: boolean;
}

export const DataCollectionDocumentType = {
    Id: 'IDENTITY_CARD',
    Passport: 'PASSPORT',
} as const;
export type DataCollectionDocumentType = typeof DataCollectionDocumentType[keyof typeof DataCollectionDocumentType];

export const screenStateTypesHub = {
    verificationHub: 'verificationHub',
    startingVerification: 'startingVerification',
    completeRegistration: 'completeRegistration',
    uploadAdditionalDocument: 'uploadAdditionalDocument',
} as const;
export type screenStateTypesHubTypes = typeof screenStateTypesHub[keyof typeof screenStateTypesHub];

export type DataCollectionFields = {
    citizenship: Field;
    countryOfBirth: Field;
    issuingCountry: Field;
    documentType: SwitchField<DataCollectionDocumentType>;
    documentNumber: Field;
    documentExpiration?: Field;
};

export type GeneralEventDto = Pick<EventDto, 'darklyExpId'|'kycStatus'>;
export type IntroEventDto = Pick<EventDto, keyof GeneralEventDto | 'completedRegistration'>;
export type EntryEventDto = Pick<EventDto, keyof IntroEventDto | 'source'>;
export type SelectDocumentEventDto = Pick<EventDto, keyof IntroEventDto | 'type'>;
export type ImageUploadSecondEventPayload = Pick<EventDto, keyof GeneralEventDto | 'type'>;
export type ImageUploadEventDto = Pick<EventDto, keyof ImageUploadSecondEventPayload | 'method'>;
